const _ = (data: any) => {
  const arrayOfProducts = Object.entries(data).map(product => product[1]);
  return arrayOfProducts.map((product: any) => {
    return {
      name: product.productNumber,
      id: product.productNumber,
      price: product.unitPrice,
      brand: product.manufacturerCode,
      quantity: product.quantity,
      coupon: ''
    };
  });
};

const extractShippingCost = (termsOfShipping: string) => {
  const terms = termsOfShipping.split(' ');
  return terms[0] ? terms[0].substr(1) : '0.0';
};

export default (data: any, event: string) => {
  const dataLayerObject = _(data.res.orderInfo.items);
  return {
    event,
    ecommerce: {
      purchase: {
        actionField: {
          id: data.res.orderConfirmationId,
          revenue: data.res.total,
          tax: data.res.tax,
          shipping: data.shipping ? extractShippingCost(data.shipping) : '0.0'
        },
        products: [...dataLayerObject]
      }
    }
  };
};
